import React, { useEffect, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Morph } from '../../types/Morph';


export const MorphSelect = ({
  morphs,
  morphTyped,
  morph,
  id,
  getCurrentText = () => { },
  showError = true,
  isSpecies = false
}: {
  morphs: Morph[],
  morphTyped: Function,
  morph: Morph | null,
  id: string,
  getCurrentText?: Function,
  showError?: boolean,
  isSpecies?: boolean
}) => {
  const ref = React.createRef();
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [hasText, setHasText] = useState<boolean>(false);

  useEffect(() => {
    if (morph?.name === '') {
      ref.current.clear();
      setIsValid(null);
      setHasText(false);
    }
  }, [morph])

  return (
    <React.Fragment>
      <div className={`has-validation my-3`}>
        <Typeahead
          id={id}
          key={id}
          isValid={!!isValid}
          onChange={(value) => {
            if (value.length > 0) {
              morphTyped(value[0]);
            }
            setIsValid(value.length > 0);
          }}
          onInputChange={(event) => { setHasText(event !== ""); getCurrentText(event) }}
          placeholder={isSpecies ? "Species Name" : "Morph Name"}
          defaulSelected={[morph]}
          options={morphs}
          labelKey={"name"}
          ref={ref}
        />
        {!isValid && hasText && showError && <div className="text-danger">Morph is unknown. Ignoring</div>}
      </div>
    </React.Fragment>
  )
}